import { render } from "./MainContent.vue?vue&type=template&id=1fe2249f&scoped=true"
import script from "./MainContent.vue?vue&type=script&lang=js"
export * from "./MainContent.vue?vue&type=script&lang=js"

import "./MainContent.vue?vue&type=style&index=0&id=1fe2249f&scoped=true&lang=scss"

import exportComponent from "/home/nasu/nodejs/syakkinsoudan/ikeda-line/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe2249f"]])

export default __exports__